import { organizationHierachyApiFactory } from "./apiFactoryModules/organizationHierachy";
import { authApiFactory } from "./apiFactoryModules/auth";
import { rolesAndPrivilegesApiFactory } from "./apiFactoryModules/rolesAndPrivileges";
import { securityPolicyApiFactory } from "./apiFactoryModules/securityPolicy";
import { usersAndGroupsApiFactory } from "./apiFactoryModules/usersAndGroups";
import { locationAndTaxApiFactory } from "./apiFactoryModules/locationAndTax";
import { routesApiFactory } from "./apiFactoryModules/routes";
import { vehiclesApiFactory } from "./apiFactoryModules/vehicles";
import { globalApiFunctions } from "./apiFactoryModules/globalApiFactory";
import { imageUploadFactory } from "./imageUpload";
import { bookingsApiFactory } from "./apiFactoryModules/bookings";
import { approval } from "./apiFactoryModules/approval";
import { pricingAndCollectionsApiFactory } from "./apiFactoryModules/pricingAndCollections";
import { consolidationsApiFactory } from "./apiFactoryModules/consolidations";
import { fleetFactory } from "./apiFactoryModules/fleets";
import { crmApiFactory } from "./apiFactoryModules/crm";
import { locationsApiFactory } from "./apiFactoryModules/locations";
import { domainsApiFactory } from "./apiFactoryModules/domains";
import { incidentRequestApiFactory } from "./apiFactoryModules/incidentRequest";
import { paymentsApiFactory } from "./apiFactoryModules/payments";
import { dispatchApiFactory } from "./apiFactoryModules/dispatch"
import { requestApiFactory } from "./apiFactoryModules/requests";
import { billingAndCollectionFactory } from "./apiFactoryModules/billingandcollection";
import { quoteAndDraftApiFactory } from "./apiFactoryModules/quoteAndDraft";
import { Notification } from  "./apiFactoryModules/notification"

const apiFactory = {
  ...approval,
  ...pricingAndCollectionsApiFactory,
  ...authApiFactory,
  ...rolesAndPrivilegesApiFactory,
  ...securityPolicyApiFactory,
  ...usersAndGroupsApiFactory,
  ...locationAndTaxApiFactory,
  ...organizationHierachyApiFactory,
  ...routesApiFactory,
  ...vehiclesApiFactory,
  ...globalApiFunctions,
  ...imageUploadFactory,
  ...bookingsApiFactory,
  ...consolidationsApiFactory,
  ...crmApiFactory,
  ...locationsApiFactory,
  ...domainsApiFactory,
  ...incidentRequestApiFactory,
  ...paymentsApiFactory,
  ...fleetFactory,
  ...dispatchApiFactory,
  ...requestApiFactory,
  ...billingAndCollectionFactory,
  ...quoteAndDraftApiFactory,
  ...Notification
};

export default apiFactory;
